import {Icon, type IconProps} from '@wandb/components';
import React from 'react';

import {type RunHistoryKeyType} from '../../../types/run';

type KeyTypeIconProps = {
  isApiAddedPanel: boolean;
  keyType?: RunHistoryKeyType;
};

type IconName = IconProps['icon'];

// https://www.figma.com/design/AbybbouWhi78Bp99M1FX2B/Workspace-settings-2.0-(May-2024)?node-id=4031-139086&node-type=FRAME&t=j5vaLJjJzBvDUsmv-0
const keyTypeToIconMap: {[keyType in RunHistoryKeyType]?: IconName} = {
  audio: 'music-audio',
  'audio-file': 'music-audio',
  bokeh: 'bokeh',
  'bokeh-file': 'bokeh',
  histogram: 'chart-vertical-bars',
  html: 'code-alt',
  'html-file': 'code-alt',
  images: 'photo-picture',
  'image-file': 'photo-picture',
  'images/separated': 'photo-picture',
  molecule: 'molecule',
  'molecule-file': 'molecule',
  number: 'number-hashtag',
  object3D: 'cube-container',
  'object3D-file': 'cube-container',
  plotly: 'plotly',
  'plotly-file': 'plotly',
  string: 'type-string-alt',
  table: 'table',
  'table-file': 'table',
  videos: 'video-play',
  'video-file': 'video-play',
  unknown: 'help-alt',
};

export const KeyTypeIcon = ({keyType, isApiAddedPanel}: KeyTypeIconProps) => {
  let iconName: IconName | undefined;
  if (keyType) {
    iconName = keyTypeToIconMap[keyType];
  } else if (isApiAddedPanel) {
    iconName = 'code-alt';
  }

  if (!iconName) {
    return <div className="h-18 w-18" />;
  }
  return <Icon icon={iconName} mt={1} />;
};
